import { GQLResponse } from './GQLTypes';

export async function getResult (response: Response): Promise<GQLResponse | string> {
  const contentType = response.headers.get('Content-Type');
  if (contentType?.startsWith('application/json')) {
    return response.json();
  } else {
    return response.text();
  }
}
